<div class="container mt-5">
  @if (hasApiError) {
    <div class="alert alert-danger" role="alert">
      {{apiError}}
    </div>
  }
  <table mat-table [dataSource]="dataSource">

    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef> Id </th>
      <td mat-cell *matCellDef="let element"><a routerLink="/log/{{element.id}}">{{element.id}}</a></td>
    </ng-container>

    <ng-container matColumnDef="associated_job_id">
      <th mat-header-cell *matHeaderCellDef>Job</th>
      <td mat-cell *matCellDef="let element"><a
      routerLink="/geometry/{{element.associated_job_id}}">{{element.associated_job_id}}</a> </td>
    </ng-container>

    <ng-container matColumnDef="creation_date">
      <th mat-header-cell *matHeaderCellDef>Recorded</th>
      <td mat-cell *matCellDef="let element"> {{element.creation_date}} </td>
    </ng-container>

    <ng-container matColumnDef="node">
      <th mat-header-cell *matHeaderCellDef>Node</th>
      <td mat-cell *matCellDef="let element"> {{element.node}} </td>
    </ng-container>

    <ng-container matColumnDef="level">
      <th mat-header-cell *matHeaderCellDef>Level</th>
      <td mat-cell *matCellDef="let element"> {{element.level}} </td>
    </ng-container>

    <ng-container matColumnDef="service">
      <th mat-header-cell *matHeaderCellDef>Service</th>
      <td mat-cell *matCellDef="let element"> {{element.service}} </td>
    </ng-container>

    <ng-container matColumnDef="code">
      <th mat-header-cell *matHeaderCellDef>Code</th>
      <td mat-cell *matCellDef="let element"> {{element.code}} </td>
    </ng-container>

    <ng-container matColumnDef="message">
      <th mat-header-cell *matHeaderCellDef>Message</th>
      <td mat-cell *matCellDef="let element"> {{element.message}} </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef> Actions </th>
      <td mat-cell *matCellDef="let element"><a (click)="deleteLog(element.id)" href="javascript:void(0)">Delete</a>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>
<mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons aria-label="Select page of logs">
</mat-paginator>
</div>